/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Body_create_person_v1_workspace__slug__integrations_pipedrive_persons_post } from '../models/Body_create_person_v1_workspace__slug__integrations_pipedrive_persons_post';
import type { PipedriveDeal } from '../models/PipedriveDeal';
import type { PipedriveLead } from '../models/PipedriveLead';
import type { PipedriveOrganization } from '../models/PipedriveOrganization';
import type { PipedrivePerson } from '../models/PipedrivePerson';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class PipedriveService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Redirect To Webapp
   * 개발환경에서 Pipedrive 연동시 인증코드를 webapp 대신 받아 리디렉션 합니다.
   * (이상하게도) Pipedrive는 연동앱을 활성화 하려면 외부 접근 가능한 리디렉션 URL을 제공해야합니다.
   * 실제 환경에서는 인증코드를 webapp 주소로 바로 넘겨주기 떄문에 본 api를 호출할 일이 없습니다.
   * 따라서 이 경우엔 404를 반환합니다.
   * @returns void
   * @throws ApiError
   */
  public redirectToWebappV1WorkspaceSlugIntegrationsPipedriveGet(): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/workspace/{slug}/integrations/pipedrive',
      errors: {
        307: `Successful Response`,
        404: `Not Found`,
      },
    });
  }

  /**
   * Create Person
   * @param slug
   * @param requestBody
   * @returns PipedrivePerson Successful Response
   * @throws ApiError
   */
  public createPersonV1WorkspaceSlugIntegrationsPipedrivePersonsPost(
    slug: string,
    requestBody: Body_create_person_v1_workspace__slug__integrations_pipedrive_persons_post
  ): CancelablePromise<PipedrivePerson> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/v1/workspace/{slug}/integrations/pipedrive/persons',
      path: {
        slug: slug,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Get Organizations
   * @param id organization id
   * @param slug
   * @returns PipedriveOrganization Successful Response
   * @throws ApiError
   */
  public getOrganizationsV1WorkspaceSlugIntegrationsPipedriveOrganizationsIdGet(
    id: number,
    slug: string
  ): CancelablePromise<PipedriveOrganization> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/workspace/{slug}/integrations/pipedrive/organizations/{id}',
      path: {
        id: id,
        slug: slug,
      },
      errors: {
        400: `Bad Request`,
        402: `Payment Required`,
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }

  /**
   * Search
   * @param slug
   * @param keyword search keyword
   * @param t
   * @returns any Successful Response
   * @throws ApiError
   */
  public searchV1WorkspaceSlugIntegrationsPipedriveSearchGet(
    slug: string,
    keyword?: string | null,
    t?: Array<'person' | 'lead' | 'deal'>
  ): CancelablePromise<Array<PipedriveLead | PipedriveDeal | PipedrivePerson>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/workspace/{slug}/integrations/pipedrive/search',
      path: {
        slug: slug,
      },
      query: {
        keyword: keyword,
        t: t,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
